import { render, staticRenderFns } from "./CategoriesGroup.vue?vue&type=template&id=8ab1ab84&scoped=true"
import script from "./CategoriesGroup.vue?vue&type=script&lang=js"
export * from "./CategoriesGroup.vue?vue&type=script&lang=js"
import style0 from "./CategoriesGroup.vue?vue&type=style&index=0&id=8ab1ab84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab1ab84",
  null
  
)

export default component.exports